import React from "react";
import { AlertCircle, UserCheck, UserPlus, X } from "lucide-react";

/**
 * Modal when a phone number matches an existing client.
 * Props:
 *  - open: boolean
 *  - existing: {id, nome, telefone, bairro}
 *  - onUseExisting(client)
 *  - onCreateAnyway()
 *  - onCancel()
 *  - mode: "scan" | "manual" | "edit"
 */
export default function DuplicatePhoneModal({ open, existing, onUseExisting, onCreateAnyway, onCancel, mode = "manual" }) {
  if (!open || !existing) return null;
  const canCreateAnyway = mode !== "edit";
  return (
    <div
      className="fixed inset-0 z-50 bg-black/55 flex items-end sm:items-center justify-center p-4"
      onClick={onCancel}
      data-testid="duplicate-phone-modal"
    >
      <div
        className="bg-white rounded-2xl p-5 w-full max-w-md animate-slide-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-2 mb-3">
          <div className="w-10 h-10 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center">
            <AlertCircle className="w-5 h-5" />
          </div>
          <h3 className="font-display text-lg font-bold text-stone-900">Esse telefone já está cadastrado</h3>
        </div>
        <div className="bg-stone-50 border border-stone-200 rounded-xl p-3 mb-4">
          <div className="text-[10px] font-bold uppercase tracking-wider text-stone-500">Cliente existente</div>
          <div className="font-display text-base font-bold text-stone-900">{existing.nome}</div>
          <div className="text-xs text-stone-500 mt-0.5">
            {existing.telefone}
            {existing.bairro ? ` • ${existing.bairro}` : ""}
          </div>
        </div>
        <p className="text-sm text-stone-600 mb-4">
          {mode === "edit"
            ? "Outro cadastro seu já tem esse número. Quer salvar mesmo assim ou cancelar a troca?"
            : "Quer usar o cadastro antigo (recomendado) ou criar um cliente novo mesmo assim?"}
        </p>
        <div className="grid grid-cols-1 gap-2">
          {mode !== "edit" && (
            <button
              data-testid="btn-duplicate-use-existing"
              onClick={() => onUseExisting(existing)}
              className="btn-primary w-full"
            >
              <UserCheck className="w-4 h-4" /> Usar esse cliente
            </button>
          )}
          {canCreateAnyway && (
            <button
              data-testid="btn-duplicate-create-anyway"
              onClick={onCreateAnyway}
              className="h-12 rounded-xl border-2 border-stone-300 font-bold text-stone-700 inline-flex items-center justify-center gap-2 hover:bg-stone-50"
            >
              <UserPlus className="w-4 h-4" /> Criar novo mesmo assim
            </button>
          )}
          {mode === "edit" && (
            <button
              data-testid="btn-duplicate-save-anyway"
              onClick={onCreateAnyway}
              className="btn-primary w-full"
            >
              Salvar mesmo assim
            </button>
          )}
          <button
            data-testid="btn-duplicate-cancel"
            onClick={onCancel}
            className="h-10 rounded-xl font-bold text-stone-500 hover:text-stone-800 inline-flex items-center justify-center gap-1"
          >
            <X className="w-4 h-4" /> Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
